export default __webpack_public_path__ + "static/media/workLocations.b5da961b.png";